import { useDisclosure } from '@heroui/react';
import { useTranslations } from 'next-intl';
import Image from 'next/image';
import React from 'react';
import ModalTemplate from './modal-template';

type AverageTariffTitleProps = {
  styles: string;
};
export default function AverageTariffTitle({
  styles,
}: AverageTariffTitleProps) {
  const t = useTranslations('priceComparison.averageTariff');
  const { onOpen, onOpenChange, isOpen } = useDisclosure();

  return (
    <div>
      <div className="flex flex-row gap-x-[6px] pl-1 sm:pl-3 md:pl-6 items-start">
        <div
          data-testid="average-tariff-info-trigger"
          onClick={onOpen}
          className="bg-transparent cursor-pointer"
        >
          <Image
            data-testid="average-tariff-info-icon"
            src="/images/info-icon.svg"
            alt="info icon"
            width={20}
            height={20}
            className="pt-[2px] mb-6 md:mb-0"
          />
        </div>
        <p
          data-testid="average-tariff-info-title"
          className={`${styles} text-[var(--color-text-subtle)] text-right`}
        >
          {t('title')}
        </p>
      </div>
      <ModalTemplate
        isOpen={isOpen}
        onOpenChange={onOpenChange}
        title={t('modalTitle')}
      >
        <p data-testid="average-tariff-info-body">{t('modalBody')}</p>
      </ModalTemplate>
    </div>
  );
}
